import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const apiClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const getCurrentData = async (ticker = 'SPY') => {
    const response = await apiClient.get('/data/current', {
        params: { ticker },
    });
    return response.data;
};

export const getGEXHeatmap = async (ticker = 'SPY', expirations, scaling = 'notional') => {
    const response = await apiClient.get('/gex/heatmap', {
        params: {
            ticker,
            expirations: expirations.join(','),
            scaling,
        },
    });
    return response.data;
};

export const getHistory = async (ticker = 'SPY', limit = 1000) => {
    const response = await apiClient.get('/data/history', {
        params: { ticker, limit },
    });
    return response.data;
};

export default apiClient;
